// extracted by mini-css-extract-plugin
export default {"scenarioOptionsTable":"ScenariosTable_scenarioOptionsTable__z8aIh"};